import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareAdvancedRoadmapsGettingStartedRedirectRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps-getting-started-redirect',
	path: '/secure/PortfolioGettingStarted.jspa',
};
